import { Uuid } from '~/eds/src/types/Uuid';
import { everest } from '~/services/serviceInstances';

export interface SupplierContactPayload {
  supplier_contact_wss_id: string;
  email: string;
}

interface ShareSupplierNegotiationPayload {
  action: 'share';
  version_id: string;
  contract_id: string;
  supplier_company_wss_id: string;
  supplier_contacts: SupplierContactPayload[];
}

interface RetractSupplierNegotiationPayload {
  action: 'retract';
  version_id: string;
  contract_id: string;
}

type SupplierNegotiationPayload =
  | ShareSupplierNegotiationPayload
  | RetractSupplierNegotiationPayload;

export interface SupplierNegotiationSuccessResponse {
  data: {
    status: string;
    action: string;
  };
}

type Request = {
  ticketId: Uuid;
  payload: SupplierNegotiationPayload;
};

export const postTicketSupplierNegotiation = async ({
  ticketId,
  payload,
}: Request): Promise<SupplierNegotiationSuccessResponse> => {
  return everest.post(`/tickets/${ticketId}/supplier-negotiation`, payload);
};
